import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-google",
  "use": "icon-google-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-google\"><path d=\"M16.636 13.999V18.8h7.94c-.323 2.06-2.402 6.037-7.94 6.037-4.78 0-8.679-3.959-8.679-8.837s3.9-8.837 8.679-8.837c2.718 0 4.54 1.16 5.579 2.159l3.8-3.659C23.578 3.38 20.417 2 16.639 2c-7.739 0-14 6.262-14 14s6.261 14 14 14c8.078 0 13.442-5.682 13.442-13.678 0-.919-.098-1.618-.22-2.319l-13.222-.005h-.002Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol